module.exports = __webpack_public_path__ + "static/media/sademoji.ed714f66.svg";